import React, { PureComponent } from 'react'
import { clone } from 'ramda'
import { Input } from "@driftt/tide-core-legacy"

class InputFilter extends PureComponent {

  state = {
    value: ''
  }

  onValueUpdated = (event) => {
    const { onUpdateCondition, activeFilter } = this.props
    const value = event.target.value

    const newFilter = clone(activeFilter)

    newFilter.value = value

    this.setState({
      value: value
    })

    onUpdateCondition(newFilter)
  }

  render() {
    const { value } = this.state

    return (
      <div className="rules-choice-content drift-form">
        <Input value={value} onChange={this.onValueUpdated}/>
      </div>
    )
  }
}

export default InputFilter


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/InputFilter.js